import React, { useState, useEffect, useCallback } from "react";
import RankingBoard from "src/components/home/RankingBoard";
import { useSelector } from "react-redux";
import { RootState } from "src/store/store";
import { ListParam, defaultListParam } from "src/types/api/listParam";
import { getScoreRank, getSubRank, getHotRank } from "src/api/ChannelApi";

interface RankingContainerProps {
  rowPerPage: number;
}

const RankingContainer: React.FC<RankingContainerProps> = ({ rowPerPage }) => {
  const rankTab = useSelector((state: RootState) => state.tab.rankTab);
  const rankCategoryId = useSelector((state: RootState) => state.category.rankCategoryId);
  const [rankcontents, setRankContents] = useState([]);
  const [curPage, setCurPage] = useState(null);
  const [date, setDate] = useState('')
  const [isMore, setIsMore] = useState(true); 

  const serviceType = useSelector((state: RootState) => state.session.serviceType);

  const fetchData = useCallback(async (params: ListParam) => {
    try{
      let response;
      if (params.category_id === 0) {
        params.category_id = null;
        response = await getHotRank(params);  
      }
      else {
        if (rankTab === "스코어"){
          response = await getScoreRank(params);
        }
        else if (rankTab === "구독자"){
          response = await getSubRank(params);
        }
      }
  
      const newData = response?.data?.list || [];
      if ( newData.length < rowPerPage ){
        setIsMore(false)
      } else {
        setIsMore(true)
      }
      if (params.curPage === 1) {
        setRankContents(newData);
        setDate(response?.data?.param.yyyymmdd || [])
      } else {
        setRankContents((prevData) => [...prevData, ...newData]); 
      }
    } catch (error) {
        console.error("API 호출 실패:", error);
        if (params.curPage === 1) setRankContents([]);
    }
  }, [rowPerPage, rankTab]);
  
  useEffect(() => { 
    setCurPage(null);
    const defaultParams = defaultListParam();
    defaultParams.category_id = rankCategoryId;
    defaultParams.rowPerPage = rowPerPage;
    defaultParams.service_type = serviceType;
    fetchData(defaultParams);
  }, [rankCategoryId, rowPerPage, serviceType, fetchData]);

  const handleLoadMore = async () => {
    try {
      const defaultParams = defaultListParam();
      const newPage = curPage === null ? 2 : curPage + 1;
      defaultParams.category_id = rankCategoryId;
      defaultParams.rowPerPage = rowPerPage;
      defaultParams.curPage = newPage;
      defaultParams.yyyymmdd = date;
      defaultParams.service_type = serviceType;
      await fetchData(defaultParams);
      setCurPage(newPage);
    } catch (error) {
        console.error("추가 데이터 로드 실패:", error);
    }
  };

  return (
    <RankingBoard contents={rankcontents} isMore={isMore} handleLoadMore={handleLoadMore} date={date} />
  );
};

export default RankingContainer;
